
@if(show){
    <div class="sx-information-pane" id="information_pane">

        @if (!showCard) {
            <section>
                <mat-expansion-panel 
                    [hidden]="hidden"
                    [expanded]="informationGroupView.expanded" 
                    (opened)="panelOpened(informationGroupView)" 
                    (closed)="panelClosed(informationGroupView)">
                    @if (showHeader){
                        <mat-expansion-panel-header 
                            [collapsedHeight]="'80px'" 
                            [expandedHeight]="'80px'" 
                            class="sx-information-pane__group">
                            <div class="sx-information-pane__group--iconwrapper">
                                <div class="sx-information-pane__section sx-information-pane__section--exergi">
                                    <svg class="sx-information-pane__group--icon">
                                            <use xlink:href="#sx-exergi" href="#sx-exergi" />
                                    </svg>
                                    @if(informationGroupView.unReadCount > 0){
                                        <span class="sx-information-pane__unread-count"
                                            [matBadge]="informationGroupView.unReadCount"
                                            [matBadgeOverlap]="true" 
                                            [matBadgeHidden]="false">
                                        </span>
                                    }

                                    <span class="sx-information-pane__group--icon-text">{{iconText | translate}}</span>
                                </div>
                            </div>
                            <div class="sx-information-pane__group--contentwrapper">
                                <mat-panel-title>
                                    <h2 class="h3 sx-information-pane__group--heading">{{informationGroupView.title}}</h2>
                                </mat-panel-title>
                            </div>
                        </mat-expansion-panel-header>
                    }

                    <div class="sx-information-pane__item" id="information_pane_items">
                        <mat-accordion>
                            @for(information of informationGroupView.informations; track information;){
                                <div>
                                    <mat-expansion-panel [expanded]="information.expanded">
                                        <mat-expansion-panel-header [collapsedHeight]="'80px'" [expandedHeight]="'80px'" (click)="togglePanelItem(information)">
                                            <div class="sx-information-pane__item--iconwrapper">
                                                <div class="sx-information-pane__section sx-information-pane__section--item">
                                                    @if(information.informationType === informationTypeEnum.Information){
                                                        <svg class="sx-information-pane__icon">
                                                            <use xlink:href="#sx-installator" href="#sx-installator" />
                                                        </svg>
                                                    }
                                                    @if(information.informationType === informationTypeEnum.Help){
                                                        <svg class="sx-information-pane__icon">
                                                            <use xlink:href="#sx-party" href="#sx-party" />
                                                        </svg>
                                                    }
                                                    @if(information.informationType === informationTypeEnum.Promotion){
                                                        <svg class="sx-information-pane__icon">
                                                            <use xlink:href="#sx-introduktion" href="#sx-introduktion" />
                                                        </svg>
                                                    }
                                                    @if(!information.isRead && showIsRead){
                                                        <span class="sx-information-pane__section--unread-count" 
                                                            [matBadge]="0"
                                                            [ngClass]="{'hide-text': true}"
                                                            [matBadgeOverlap]="true" 
                                                            [matBadgeHidden]="false" 
                                                            matBadgeSize="small">
                                                        </span>
                                                    }
                                                    @switch(information.informationType){
                                                        @case(informationTypeEnum.User){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Anvandare.png" alt="Användare" /> 
                                                        }
                                                        @case(informationTypeEnum.Environment){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Miljo.png" alt="Miljö" /> 
                                                        }
                                                        @case(informationTypeEnum.Contract){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Avtal.png" alt="Avtal" /> 
                                                        }
                                                        @case(informationTypeEnum.Brf){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Bostadsratt.png" alt="Bostadsrätt" /> 
                                                        }
                                                        @case(informationTypeEnum.Exergi){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Exergi.png" alt="Exergi" /> 
                                                        }
                                                        @case(informationTypeEnum.Invoice){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Faktura.png" alt="Faktura" /> 
                                                        }
                                                        @case(informationTypeEnum.Error){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Fel_Identifierat.png" alt="Fel identifierat" /> 
                                                        }
                                                        @case(informationTypeEnum.Company){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Foretag.png" alt="Företag" /> 
                                                        }
                                                        @case(informationTypeEnum.Ok){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Fungerar_Bra.png" alt="Fungerar bra" /> 
                                                        }
                                                        @case(informationTypeEnum.Heart){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Heart.png" alt="Hjärta" /> 
                                                        }
                                                        @case(informationTypeEnum.Contact){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Kontakt.png" alt="Kontakt" /> 
                                                        }
                                                        @case(informationTypeEnum.ContactInformation){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Kontaktuppgifter.png" alt="Kontaktuppgifter" /> 
                                                        }
                                                        @case(informationTypeEnum.CustomerSupport){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Kundservice.png" alt="Kundservice" /> 
                                                        }
                                                        @case(informationTypeEnum.Cold){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Kyla.png" alt="Kyla" /> 
                                                        }
                                                        @case(informationTypeEnum.Location){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Position.png" alt="Position" /> 
                                                        }
                                                        @case(informationTypeEnum.Waste){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Restprodukter.png" alt="Restprodukter" /> 
                                                        }
                                                        @case(informationTypeEnum.Private){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Smahus.png" alt="Småhus" /> 
                                                        }
                                                        @case(informationTypeEnum.Stockholm){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Stockholm.png" alt="Stockholm" /> 
                                                        }
                                                        @case(informationTypeEnum.Phone){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Telefon.png" alt="Telefon" /> 
                                                        }
                                                        @case(informationTypeEnum.Hot){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Varme.png" alt="Värme" />
                                                        }
                                                        @case(informationTypeEnum.Intelligy){
                                                            <img class="sx-information-pane__icon" src="/assets/icons/Morkgra_Intelligy.png" alt="Intelligy" /> 
                                                        }
                                                    }
                                                </div>
                                            </div>
                                            <div class="sx-information-pane__item--contentwrapper">
                                                <div class="sx-information-pane__section sx-information-pane__section--grow sx-information-pane__titlewrapper">
                                                    <mat-panel-title>
                                                        <div class=" sx-information-pane__item--heading" [ngClass]="{'sx-message__item-title--unread': !information.isRead}">{{information.title}}</div>
                                                    </mat-panel-title>
                                                </div>
                                            </div>
                                        </mat-expansion-panel-header>
                                        <div class="sx-information-pane__item--content sxh-flex">
                                            <div class="sx-information-pane__item--content-left">
                                                <div class="sxh-text-light">{{ information.publishedDate | localDate: 'yyyy-MM-dd' }}</div>
                                                @if(information?.content){
                                                    <div [innerHtml]="information.content | safeHtml" appRouterLink></div>
                                                }
                                            </div>
                                            <div class="sx-information-pane__item--content-right">
                                                @if(information.imageUrl && !information.videoUrl){
                                                    <div class="sx-information-pane__item--imagewrapper">
                                                        <img src="{{information.imageUrl}}" />
                                                    </div>
                                                }
                                                @if(information.videoUrl){
                                                    <div class="sx-information-pane__item--imagewrapper">
                                                        <iframe credentialless id="Iframe" [src]="information.videoUrl|safeResourceUrl" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                                                    </div>
                                                }
                                            </div>
                                        </div >
                                    </mat-expansion-panel>
                                </div>
                            }

                        </mat-accordion>
                    </div> 
                </mat-expansion-panel>
            </section>
        }
        @if (showCard) {
            <section>
                <div class="sx-information-card__wrapper">
                    @if(informationGroupView?.informations){
                        <div class="sxl-container">
                            @for(information of informationGroupView.informations; track information;){
                                <div class="sxl-item sxl-item--3">
                                    <article class="sx-information-card" >
                                        <div class="sxl-grow">
                                            @if(information?.imageUrl && !information?.videoUrl){
                                                <div class="sx-information-card__image">
                                                    <img src="{{information.imageUrl}}" />
                                                </div>
                                            }
                                            @if(information?.videoUrl){
                                                <div class="sx-information-card__imagewrapper">
                                                    <iframe credentialless [src]="information.videoUrl|safeResourceUrl" credentialless frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                                                </div>
                                            }
                                            <div class="sx-information-card__content">
                                                <div class="sx-information-card__row">
                                                    <div class="sx-information-card__row-fragment">
                                                        @if(information?.title ){
                                                            <h3 [innerHtml]="information.title"></h3>
                                                        }
                                                        @if(information?.content){
                                                            <p [innerHtml]="information.content | safeHtml" appRouterLink></p>
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            }
                        </div>
                    }
                </div>
            </section>
        }
    </div>
}


